module.exports = __webpack_public_path__ + "img/alarm-record.573e4039.png";